import { createElement } from 'react';

import type { IconProps } from '../icon/icon';
import { Icon } from '../icon/icon'; // props is just passed in to keep variables.jsx happy. We don’t use variables.props
const SvgEditIcon = (componentProps: IconProps, props = {}) => {
  return createElement(
    Icon,
    componentProps,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      {...props}
    >
      <g
        fill="#353C4A"
        fillRule="evenodd"
        clipPath="url(#edit-icon_svg__a)"
        clipRule="evenodd"
      >
        <path d="M6.181 23.625c-.717.1-1.3-.571-1.1-1.267l1.443-5.035a1 1 0 0 1 .304-.477L19.616 5.73a1 1 0 0 1 1.41.1l3.742 4.305a1 1 0 0 1-.097 1.41L11.883 22.66a1 1 0 0 1-.515.234zM20.172 7.896l2.43 2.796-11.807 10.264-3.368.474.938-3.27z" />
        <path d="M25.573 5.656c-.697-.803-1.844-.852-2.552-.236l-1.338 1.162 2.431 2.796 1.337-1.162c.709-.616.82-1.758.122-2.56M21.71 3.91c1.572-1.367 3.978-1.173 5.374.432 1.395 1.606 1.252 4.016-.32 5.382L23.917 12.2l-5.055-5.815zM3 27.635a1 1 0 0 1 1-1h24a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1" />
      </g>
      <defs>
        <clipPath id="edit-icon_svg__a">
          <path fill="#fff" d="M3 3h26v25.635H3z" />
        </clipPath>
      </defs>
    </svg>,
  );
};
export default SvgEditIcon;
